module.exports = __webpack_public_path__ + "img/somaliland.9bb4e3a.webp";